import { FunctionComponent, useEffect, useRef } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import StorageService from '../services/storage/storage.service'
import NotFound from '../pages/404/NotFound'
import LandingPage from '../pages/landing-page/LandingPage'
import PrivateRoutes from './PrivateRoute'
import MarketPlace from '../pages/marketplace/MarketPlace'
import { useAppDispatch, useAppSelector } from '../store/storeRequests'
import { getUserDetails } from '../store/authentication/authentication.actions'
import Policies from '../pages/policies/Policies'
import CartPage from '../pages/cart/CartPage'
import StoreSelectors from '../utils/constants/StoreSelectors.constants'
import LoginModal from '../components/Modal/LoginModal'
import RightModal from '../components/Modal/RightModal'
import APIDetailsPage from '../pages/api-details/APIDetailsPage'
import UATConfirmationPage from '../pages/UATConfirmation/UATConfirmationPage'
import UATOrders from '../pages/UATOrders/UATOrders'
import APIsListing from '../pages/APIsListing/APIsListing'
import Legal from '../pages/legal/Legal'
import LiveAPI from '../pages/LiveAPI/LiveAPI'
import Commercials from '../pages/commercials/Commercials'
import Checkout from '../pages/checkout/Checkout'
import Requests from '../pages/requests/Requests'
import ProfilePage from '../pages/profile-page/ProfilePage'
import Wishlist from '../pages/wishlist/Wishlist'
import TicketView from '../pages/TicketView/TicketView'
import CustomToast from '../components/CustomToast/CustomToast'
import { NavList } from '../utils/constants/navigation'
import { setRedirectionUrl, setShowLoginModal } from '../store/authentication/authentication.slice'
import Maintenance from '../pages/maintenance/Maintenance'

const AppRoutes: FunctionComponent = () => {
  
  const isExecuted = useRef(false)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const currentUser = useAuth()
  const location = useLocation()
  const { showSideModal } = useAppSelector(StoreSelectors.SELECTED_STATE)
  
  useEffect(() => {
    
    if (isExecuted.current === true) {
      return
    }
    
    if (currentUser === 1 || currentUser === 2) {
      const { user } = StorageService.getFromStorage(['user'])
      if (typeof user?.token === 'string') {
        dispatch(getUserDetails())
      }
    }
    
    isExecuted.current = true
    
  }, [currentUser])

  useEffect(() => {
    
    if (currentUser === 0 && !['/terms-of-use', '/privacy-policy'].includes(location.pathname)) {
      const isSharedItemRoute = /^\/(?:api|live)\/[^/]+\/?$/.test(location.pathname)
      if (isSharedItemRoute) {
        dispatch(setRedirectionUrl(`${location.pathname}${location.search}${location.hash}`))
        dispatch(setShowLoginModal(true))
      }
      navigate(NavList.HOMEPAGE)
    }
    
  }, [currentUser, dispatch, location.hash, location.pathname, location.search, navigate])

  return (
    <>
      <LoginModal />
      <CustomToast message=''/>
      {showSideModal && <RightModal />}
        <Routes>
           <Route path={NavList.HOMEPAGE} element={ <LandingPage /> }/>
          <Route path={NavList.PRIVACY_POLICIES} element={ <Policies /> }/>
          <Route path={NavList.TERMS_OF_USE} element={ <Policies /> }/>
          {/* Private routes declaration - start*/}
          <Route path='' element={<PrivateRoutes />}>
            <Route index path={NavList.MARKET_PLACE} element={<MarketPlace /> } />
            <Route path={NavList.CART} element={<CartPage /> } />
            <Route path={`${NavList.API_DETAILS}:apiID`} element={<APIDetailsPage /> } />
            <Route path={`${NavList.ORDER_DETAILS}:orderID`} element={<UATConfirmationPage /> } />
            <Route path={NavList.ORDERS} element={<UATOrders /> } />
            <Route path={NavList.API_LISTING_PRODUCTION} element={<APIsListing /> } />
            <Route path={NavList.API_LISTING_LIVE} element={<APIsListing /> } />
            <Route path={`${NavList.LIVE_API_DETAILS}:id`} element={<LiveAPI /> } />
            <Route path={NavList.PRODUCTION_LEGAL} element={<Legal /> } />
            <Route path={NavList.PRODUCTION_COMMERCIALS} element={<Commercials /> } />
            <Route path={NavList.PRODUCTION_CHECKOUT} element={<Checkout /> } />
            <Route path={NavList.SUPPORT_REQUESTS} element={<Requests /> } />
            <Route path={`${NavList.SUPPORT_TICKET_VIEW}:id`} element={<TicketView /> } />
            <Route path={NavList.USER_PROFILE} element={<ProfilePage /> } />
            <Route path={NavList.WISHLIST} element={<Wishlist /> } />
            <Route path={NavList.NOT_FOUND} element={ <NotFound /> }/>
          </Route>
          {/* Private routes declaration - end*/}
          <Route path={NavList.NOT_FOUND} element={<NotFound />} />
        </Routes>
      </>
  )
}

export default AppRoutes